import React, { useEffect, useState } from 'react';
import styles from '../../styles/ls-request/NewLsRequestSidebar.module.scss';
import { connect } from 'react-redux';
import { LsFields } from '../../services/LsFields';
import File from '../library/File';
import { formatDateTime } from '../../utils/helper';
import parse from 'html-react-parser';
import {
	DupSearchBtnIcon,
	EditPageIcon,
	LsrRequestActivationBtnIcon,
	PaperClipIcon,
} from '../../services/SvgLibrary';
import {
	activeStatuses,
	adminRoles,
	fourthTierRoles,
	lsModelTextFields,
	nonLegDivisionRoles,
	rolesUnderCouncilMembers,
	superAdminRoles,
} from '../../services/constants';
import {
	activateLsRequest,
	openOrCloseLsRequestServicePopup,
} from '../../actions/lsRequestAction';
import { getFileAndDownload } from '../../actions/fileDownloadAction';
import LsSidebarTasks from './LsSidebarTasks';
import LsSidebarComments from './LsSidebarComments';
import NewLsHistory from './NewLsHistory';

const NewLsInfoDisplay = props => {
	const lsFieldList = JSON.parse(JSON.stringify(LsFields));
	const [filesToHighlight, setFilesToHighlight] = useState({});
	const [activating, setActivating] = useState(false);

	// Check if the URL contains "LsDup"
	const isDupSearch = window.location.pathname.includes('LsDupSearch');

	useEffect(() => {
		const highlightedFiles = {};
		if (props.highlights.file_hits) {
			for (let ls_id in props.highlights.file_hits) {
				const filesArray = props.highlights.file_hits[ls_id];
				filesArray.forEach(fileName => {
					highlightedFiles[fileName] = true;
				});
			}
		}
		setFilesToHighlight(highlightedFiles);
	}, [props.highlights])

	const createLsInfoDisplay = updateTargetLs => {

		const nonLeg = nonLegDivisionRoles.includes(props.userProfile.role);
		let filteredField = lsFieldList.filter(
			field =>
				!(nonLeg && field.viewability === 'staffOnly') &&
				field.viewability !== 'none'
		);

		let displayLsPart = filteredField.map((ls, idx) => {
			let text = '';
			let excludedArray = [
				'ls_number',
				'ls_type',
				'first_prime',
				'date_received',
				'make_first_prime_public',
			];
			if (props.infoLocation === 'sidebar') {
				excludedArray.push('submitted_by');
				excludedArray.push('status');
			}
			// Only Session 11 LSRs will have data in the background field, newer LSRs made in IWOMM won't
			if ((ls.field === 'background') & (updateTargetLs[ls.field] === '')) {
				excludedArray.push('background');
			}
			if (
				((props.infoLocation !== 'sidebar' && ls.duplicate_check) ||
					props.infoLocation === 'sidebar') &&
				(updateTargetLs[ls.field] ||
					ls.type === 'checkbox' ||
					ls.field === 'reintroduction' ||
					ls.field === 'prev_sess_ls_number') &&
				!excludedArray.includes(ls.field) &&
				!(
					(ls.type === 'multi-select' || ls.type === 'file') &&
					updateTargetLs[ls.field].length === 0
				)
			) {
				if (ls.field === 'date_received') {
					text = formatDateTime(updateTargetLs[ls.field]);
				} else if (ls.type === 'file') {
					if (updateTargetLs[ls.field].length > 0) {
						const files = updateTargetLs[ls.field];
						text = (
							<div key={idx}>
								{files.map((file, index) => {
									const { highlighted = false } = file
									return (
										<File
											id={`lsr_${ls.field}-${index}`}
											file={file}
											getFileAndDownload={props.getFileAndDownload}
											key={index}
											highlighted={highlighted}
										/>)
								})}
							</div>
						);
					} else {
						text = 'N/A';
					}
				} else if (ls.field === 'contact_person') {
					text = (
						<pre className={styles['pre']}>
							{parse(updateTargetLs[ls.field]['full_name'])}
							<br />
							{parse(updateTargetLs[ls.field]['phone'])}
							<br />
							<a href={`mailto:${updateTargetLs[ls.field]['email']}`}>
								{parse(updateTargetLs[ls.field]['email'])}
							</a>
						</pre>
					);
				} else if (ls.field === 'committee') {
					text = parse(
						updateTargetLs[ls.field] && updateTargetLs[ls.field]?.committee_name !== "Unassigned"
							? updateTargetLs[ls.field].committee_name
							: ''
					);
				} else if (ls.field === 'associated_report_tracking') {
					text =
						updateTargetLs[ls.field].length > 0
							? updateTargetLs[ls.field].map((report, idx) => (
								<React.Fragment key={report.id}>
									<a
										href={`${window.location.origin}/opReqs/${report.id}`}
										onClick={e => {
											e.preventDefault();
											window.open(
												`${window.location.origin}/opReqs/${report.id}`
											);
										}}>
										{report.title}
									</a>
									{idx === updateTargetLs[ls.field].length - 1 ? '' : ', '}
								</React.Fragment>
							))
							: 'N/A';
				} else if (ls.field === 'legislation') {
					if (updateTargetLs[ls.field].length > 0) {
						text = updateTargetLs[ls.field].map((leg, idx) => (
							<React.Fragment key={leg.file_number}>
								<a href={leg['legistar_url']} target='_blank' rel='noopener noreferrer'>
									{leg.full_law_number ? leg.full_law_number : leg.file_number}
								</a>
								{idx === updateTargetLs[ls.field].length - 1 ? '' : ', '}
							</React.Fragment>
						));
					}
				} else if (
					['first_prime', 'staff', 'submitted_by'].includes(ls.field)
				) {
					text = parse(
						updateTargetLs[ls.field] ? updateTargetLs[ls.field].full_name : ''
					);
				} else if (lsModelTextFields.includes(ls.field)) {
					updateTargetLs[ls.field] = updateTargetLs[ls.field]
						.replace(new RegExp('&lt;', 'gi'), match => '<')
						.replace(new RegExp('&gt;', 'gi'), match => '>');
					text = (
						<pre className={styles['pre']}>
							{parse(updateTargetLs[ls.field])}
						</pre>
					);
				} else if (ls.type === 'checkbox') {
					text = updateTargetLs[ls.field] ? 'Yes' : 'No';
				} else if (ls.field === 'reintroduction') {
					text =
						updateTargetLs[ls.field] === true
							? 'Yes'
							: updateTargetLs[ls.field] === false
								? 'No'
								: 'N/A';
				} else if (ls.field === 'prev_sess_ls_number') {
					text = updateTargetLs[ls.field] ? updateTargetLs[ls.field] : 'N/A';
				} else if (['overlapping_ls', 'related_ls'].includes(ls.field)) {
					text =
						updateTargetLs[ls.field].length > 0
							? updateTargetLs[ls.field]
								.sort((a, b) => (a['ls_number'] > b['ls_number'] ? 1 : -1))
								.map((ls_num, idx) => (
									<React.Fragment key={ls_num.ls_number}>
										<a
											href={`${window.location.origin
												}/lsRequestList/${ls_num.ls_number.toString()}`}
											onClick={e => {
												e.preventDefault();
												window.open(
													`${window.location.origin
													}/lsRequestList/${ls_num.ls_number.toString()}`
												);
											}}>
											{ls_num.ls_number}
										</a>
										{idx === updateTargetLs[ls.field].length - 1 ? '' : ', '}
									</React.Fragment>
								))
							: 'N/A';
				} else if (ls.field === 'last_activated') {
					let sixtyText;
					let activated = new Date(updateTargetLs[ls.field]);
					activated.setDate(activated.getDate() + 1);
					let today = new Date();
					let daysDifference = Math.ceil(
						Math.abs(today - activated) / (1000 * 60 * 60 * 24)
					); // ms * s * min * hour
					if (daysDifference <= 60) {
						sixtyText = (
							<span
								style={{
									color: '#4A5F96',
									fontSize: '.9em',
									float: 'right',
									fontWeight: 'bold',
								}}>{`${60 - daysDifference} day(s) UNTIL 60 days`}</span>
						);
					} else {
						sixtyText = (
							<span
								style={{
									color: '#CA4A4A',
									fontSize: '.9em',
									float: 'right',
									fontWeight: 'bold',
								}}>{`${daysDifference - 60} day(s) PAST 60 days`}</span>
						);
					}
					text = (
						<div key={idx}>
							{parse(updateTargetLs[ls.field])}
							{daysDifference &&
								!rolesUnderCouncilMembers.includes(props.userProfile.role) &&
								activeStatuses.includes(ls['status']) && (
									<>
										<br />
										{sixtyText}
									</>
								)}
						</div>
					);
				} else {
					text = <div key={idx}>{parse(updateTargetLs[ls.field])}</div>;
				}

				return (
					<fieldset
						className={
							props.placement === 'duplicate-check'
								? `${styles['fieldset-styles']} ${styles['duplicate-check']}`
								: styles['fieldset-styles']
						}
						key={idx}>
						<legend className={styles['fieldset-legend-styles']}>
							{ls.title}:
						</legend>
						<span className={styles['fieldset-content-styles']}>{text}</span>
					</fieldset>
				);
			}
			return null;
		});
		return displayLsPart;
	};

	// State to keep track of the active tab
	// While comments and tasks are disabled, initialize w/ empty string instead of 'comments'
	const [activeTab, setActiveTab] = useState(''); 

	const fileFields = [
		{ field: 'cm_attachment', title: 'CM Attachment' },
		{ field: 'bill', title: 'Prepared Legislation' },
		{ field: 'bill_matrix', title: 'Bill Matrix' },
		{ field: 'coversheet', title: 'Coversheet' },
		{ field: 'hearing_summary', title: 'Hearing Summary' },
		{ field: 'legal_memo', title: 'Legal Memo' },
		{ field: 'plain_language_summary', title: 'Plain Language Summary' },
		{ field: 'resource_letter', title: 'Change of Status Letter' },
	];
	const titlesToCheck = [
		'Bill Matrix',
		'Coversheet',
		'Hearing Summary',
		'Legal Memo',
		'Plain Language Summary',
		'Change of Status Letter'
	];



	// Function to change the active tab
	const handleTabClick = tabName => {
		setActiveTab(tabName);
	};

	// Drag and Drop functionality START
	document.addEventListener('DOMContentLoaded', function () {
		var dropZone = document.getElementById('drop_zone');

		// Prevent default drag behaviors
		['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
			dropZone.addEventListener(eventName, preventDefaults, false);
		});

		function preventDefaults(e) {
			e.preventDefault();
			e.stopPropagation();
		}

		// Highlight drop area when item is dragged over it
		['dragenter', 'dragover'].forEach(eventName => {
			dropZone.addEventListener(eventName, highlight, false);
		});

		['dragleave', 'drop'].forEach(eventName => {
			dropZone.addEventListener(eventName, unhighlight, false);
		});

		function highlight(e) {
			dropZone.classList.add(`${styles['highlight']}`);
		}

		function unhighlight(e) {
			dropZone.classList.remove(`${styles['highlight']}`);
		}

		// Handle dropped files
		dropZone.addEventListener('drop', handleDrop, false);

		function handleDrop(e) {
			var dt = e.dataTransfer;
			var files = dt.files;

			// Handle files here (e.g., upload them, display their names)
			handleFiles(files);
		}

		function handleFiles(files) {
			[...files].forEach(uploadFile);
		}

		function uploadFile(file) {
			// You can upload file here or display file information
			console.log('File:', file.name);
		}
	});

	// Drag and drop functionality END

	function getInfoClass(location) {
		if (location === 'sidebar') {
			return styles['info-sidebar-css']; //Ls request sidebar
		} else {
			return styles['info-select-css']; // Left side of duplicate checker
		}
	}

	function onOpenUpdate() {
		props.onChangeToUpdate();
		props.onGetLsRequest();
		document.body.style.overflow = 'hidden';
	}

	function requestActivation(ls) {
		const userInput = window.confirm(
			'An activation request will be submitted and reviewed internally.\nYou will be notified upon activation of any LS Request.\n\nDo you want to proceed?'
		);
		if (userInput) {
			setActivating(true);
			props.activateLsRequest(ls.ls_number);
		};
	}

	function onOpenDuplicateCheck(id) {
		window.open(
			`${window.location.origin}/lsRequestList/LsDupSearch/${id.toString()}`
		);
	}

	function onOpenSentToCM(ls) {
		props.onChangeToSentToCM();
		props.onGetLsRequest(ls);
	}

	let lsInfo = props.updateTargetLs;
	if (props.injected_ls) {
		lsInfo = props.injected_ls;
	}

	let lsDisplay = createLsInfoDisplay(lsInfo);
	return (
		props.infoLocation === 'sidebar' && (
			<>
				<div className={getInfoClass(props.infoLocation)}>
					<div className={styles['lsr-sidebar-wrapper']}>
						<div
							className={`${styles['lsr-details-container']} ${activeTab === 'change_history' && styles['lsr-details-collapsed']}`}
						>
							<div className={styles['lsr-options-wrapper']}>
								{
									lsInfo.status !== 'Withdrawn - Former CM' && (
										<button
											type="button"
											className={`btn ${styles['lsr-options-btn']} ${styles['dup-search']}`}
											onClick={() => onOpenDuplicateCheck(lsInfo.ls_number)}
										>
											<DupSearchBtnIcon width="14px" height="auto" /> Duplicate Search
										</button>
									)
								}
								{
									lsInfo.status === 'Low-Priority Hold' &&
									!lsInfo.activation_requested && (
										<button
											type="button"
											onClick={() => requestActivation(lsInfo)}
											className={`btn ${styles['lsr-options-btn']}`}
										>
											{activating ? <span className='spinner-border spinner-border-sm' role='status' aria-hidden='true'></span>: <LsrRequestActivationBtnIcon width="14px" height="auto" />} Request Activation
										</button>
									)
								}
								{/* {
									!lsInfo.status.includes('Withdrawn') && 
									<button
										className={`btn ${styles['lsr-options-btn']}`}
										onClick={() => onOpenSentToCM(lsInfo)}
										type='button'
									>
										<PaperClipIcon width="14px" height="auto" /> Send to CM
									</button>
								} */}
							</div>
							<div className={styles['lsr-main-details-container']}>
								<div className="d-flex gap-3 align-items-center">
									<span className={styles['heading']}>{`LSR #${lsInfo.ls_number} - ${parse(lsInfo.ls_type)}`}</span>
									{
										props.userProfile.permissions.lsRequest_api.change_lsrequest &&
										(lsInfo.status !== 'Withdrawn - Former CM' ||  [...superAdminRoles, ...adminRoles, ...fourthTierRoles].includes(props.userProfile.role)) && (
											<button
												type="button"
												onClick={onOpenUpdate}
											>
												<EditPageIcon />
											</button>
										)
									}
								</div>
								<div id={`${styles['ls-summary-table-container']}`} className="d-flex gap-3">
									<table id={`${styles['ls-summary-table']}`}>
										<tbody>
											<tr>
												<td>Sponsor</td>
												<td>{parse(lsInfo.first_prime.full_name)}</td>
											</tr>
											<tr>
												<td>Assigned Staff</td>
												<td>{parse(lsInfo.staff.full_name)}</td>
											</tr>
											<tr>
												<td>Submitted</td>
												<td>
													at {formatDateTime(lsInfo.date_received)}
													<br/>
													by {parse(lsInfo.submitted_by.full_name)}
												</td>
											</tr>
										</tbody>
									</table>
								</div>
								<div className={styles['status-wrapper']}>
									<span>Status</span>
									<span>{lsInfo.status}</span>
								</div>
								<div className={`d-flex flex-column w-100 ${styles['status-wrapper']}`}>
									<span>Legislative Solution</span>
									<div className={styles['paragraph-container']}>
										<div class="mb-0">{parse(lsInfo.description_legislative_solution)}</div>
									</div>
								</div>
							</div>
							<div className={styles['ls-sidebar-fields']}>{lsDisplay}</div>
						</div>
						<div className={`${styles['lsr-add-details-container']}`}>
							<div className={styles['tabs-container']}>
								<ul className="nav nav-pills">
									{ 
										["Comments", "Tasks", "Change History"].map((tab, idx) => {
											let tabSlug = tab.toLowerCase().replace(' ', '_');
											return (
												<li className="nav-item" key={idx}>
													<a
														className={`nav-link ${activeTab === tabSlug ? styles['active'] : ''}`}
														onClick={(e) => { e.preventDefault(); handleTabClick(tabSlug); }}
														href="#"
													>
														{tab}
													</a>
												</li>
											)
										})
									}
								</ul>
							</div>
							<div className={styles['lsr-add-details-wrapper']}>
								{/* Conditional rendering based on activeTab */}
								{/*
									NOTE FROM JOHN: Be advised that we should be using roles/permissions to determine who can see these. As it right now
									CM staff do NOT see any file fields except for CM Attachment when creating, editing or viewing an LSR.
								*/}
								{activeTab === 'change_history' && 
									<NewLsHistory
										ls_num={props.updateTargetLs?.ls_number}
										userProfile={props.userProfile}
									/>
								}
								{activeTab === 'comments' && <LsSidebarComments />}
								{activeTab === 'tasks' && <LsSidebarTasks />}
							</div>
						</div>
					</div>
				</div >
			</>
		)
	)
}

const mapStateToProps = state => {
	return {
		userProfile: state.userReducer.userProfile,
		userList: state.userReducer.userList,
		committeeList: state.userReducer.committees,
		updateTargetLs: state.lsRequestsReducer.updateTargetLs,
		updateTargetLsStatus: state.lsRequestsReducer.updateTargetLsStatus,
		highlights: state.lsRequestsReducer.highlights
	};
};

const mapDispatchToProps = {
	activateLsRequest,
	openOrCloseLsRequestServicePopup,
	getFileAndDownload,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewLsInfoDisplay);
